"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import ScreenLoader from "@/components/ui/ScreenLoader";
import Cookies from "js-cookie";

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    // Verificar si ya existe una preferencia en cookies
    const userPreference = Cookies.get('userPreference');
    
    if (userPreference === 'talent') {
      router.push('/landing/jobbers');
    } else if (userPreference === 'company') {
      router.push('/landing/company');
    } else {
      router.push('/landing/user-type');
    }
  }, [router]);

  // Mostrar un loading mientras se verifica y redirige
  return (
    <ScreenLoader 
      fullScreen={true}
      texts={["Just a moment..."]}
    />
  );
}
